import type { ObjectGraph } from '@jet/environment/dependencies';
import type { ClassicalSection } from '../../api/types';
import type {
    SectionEventTrigger,
    SectionInvalidationRules,
} from '../../models/invalidation/InvalidationRules';
import type { RefreshRecentlyPlayedIntent } from './recently-played/RefreshRecentlyPlayedIntent';
import type { Opt } from '@jet/environment';
import { transformSections } from '@jet-app/music-classical/utilities/transforms/sections';

export function replaceUserComponentSection(userSections, originalSections) {
    userSections.forEach((section) => {
        const sectionType = section?.type;

        const originalRPSectionIndex = originalSections.findIndex(
            (section) => section.type === sectionType,
        );

        if (originalRPSectionIndex !== -1) {
            originalSections.splice(originalRPSectionIndex, 1);
        }

        section && originalSections.splice(originalRPSectionIndex, 0, section); // Insert at original index
    });
}

export function recentlyPlayedInvalidationRules(
    refreshIntent: RefreshRecentlyPlayedIntent,
): SectionEventTrigger {
    return {
        events: [{ name: 'playActivity', delay: 1000 }],
        intent: refreshIntent,
    };
}

export function buildHomePageSections(
    sections: ClassicalSection[],
    objectGraph: ObjectGraph,
    sectionInvalidationRules: Opt<SectionInvalidationRules>,
) {
    return transformSections(sections, objectGraph)?.map((section) => {
        if (
            section.sectionKind === 'shelf' &&
            section.id === 'shelf_recently_played'
        ) {
            return {
                ...section,
                invalidationRules: sectionInvalidationRules,
            };
        }
        return section;
    });
}
